import {AfterContentChecked, ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, Output} from '@angular/core';
import {CdkDragDrop, moveItemInArray} from '@angular/cdk/drag-drop';

@Component({
  selector: 'iv-live-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})

export class HeaderComponent implements AfterContentChecked {

  constructor(private changeDetectorRef: ChangeDetectorRef) { }

  @Output() allRowsSelected: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Input() allChecked: boolean;
  @Input() isPreset: boolean;

  private _row: any;

  get row() {
    return this._row;
  }

  @Input() set row(value) {
    this._row = value;
  }

  public ngAfterContentChecked(): void {
    this.changeDetectorRef.detectChanges();
  }

  selectAllRows(event: MouseEvent) {
    event.stopPropagation();
    this.allRowsSelected.emit((<HTMLInputElement>event.target).checked);
  }

  drop(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.row, event.previousIndex, event.currentIndex);
  }
}
